import { PanelbarStructure } from "../isPanelbarDetails.js";
import { Helper } from "../../util/helper.js";
import { StringKeyDictionary } from "../../../commonInterfaces.js";
import React from "react";
export default class MachineDetails extends React.Component<any, any> {
    private translations: StringKeyDictionary<string> = {};


    componentDidMount() {
        Helper.getTranslations(["Field.Maschine.maschnr", "Field.Maschine.maschbezeichnung", "Field.Adresse.adrnr", "Field.Maschine.maschtyp", "Field.Adresse.adrname", "Field.Maschine.maogrnr", "Field.Maschine.magrnr"])
            .then(result => {
                if (Helper.hasValue(result)) {
                    this.translations = result.Data;
                    this.setState({});
                }
            });
    }

    render() {
        const data = this.props.data;
        let ort = "";
        if (Helper.hasValue(data.Ort))
            ort = data.Ort;
        return (
            <PanelbarStructure label={data.MaschBezeichnung} keyPropValue={data.MaschNr} iconName={"cogs"} url={"Machine/Edit?id=" + encodeURIComponent(data.MaschNr)}>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span>{data.MaschNr} / {data.MaschNr2}: {data.MaschBezeichnung}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.AdrName + " " + ort}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{this.translations["Field.Maschine.maogrnr"]}: {data.Obergruppe}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{this.translations["Field.Maschine.magrnr"]}: {data.Gruppe}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{this.translations["Field.Maschine.maschtyp"]}: {data.Maschtyp}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}